module.exports = __webpack_public_path__ + "static/media/home-results.8e1f3b04.jpg";